export interface ReportFindAllRequestDTO {
    name: string
    flight_ident: string
}

export interface findAllReportResponseDTO {
    data: ReportDTO[]
    paginationData: PaginationData
}

export interface PaginationData {
    page: number
    perPage: number
    prev: number
    total: number
    totalPage: number
}

export interface filtersReportDTO {
    page: number
    pageSize: number
    sort: number
    sortBy: string
    name?: string
    surname?: string
    flightIdent: string
    departureAirport: string
    arrivalAirport: string
    fromDate: string
}

export interface UserInfoDTO {
    first_name: string
    last_name: string
    email: string
    phone: string
}

export interface ReportDTO {
    id: string
    first_name: string
    last_name: string
    email: string
    phone: string
    report: string
    flight_info: FlightInfoDTO
    createdAt: Date
    active_notam: boolean
    // departures: DepartureTabDTO[]
    // arrivals: ArrivalTabDTO
    // weather: WeatherDTO
    // news: NewsAPIResponse
    // route: Route
}

export interface ReportCreateDTO {
    user_info: UserInfoDTO
    report: string
    flight: DepartureTabDTO
    // departures: DepartureTabDTO[]
    // arrivals: ArrivalTabDTO[]
    // weather: WeatherDTO
    // news: NewsAPIResponse
    // route: Route
}

export interface ReportCreareRequestDTO {
    user_info: UserInfoDTO
    // firstName?: string
    // lastName?: string
    // email?: string
    // phone?: string
    flight_ident: string
    start_date: Date
    end_date: Date
    with_news: boolean
    with_notamify: boolean
    active_notam: boolean
}

export interface ReportUpdateDTO {
    first_name: string
    last_name: string
    email: string
    phone: string
    report: string
    active_notam: boolean
}

export interface FlightInfoDTO {
    flight: FlightDTO
    diverted_flight: FlightDTO
    departures: DepartureTabDTO[]
    arrivals: ArrivalTabDTO[]
    departure_airport_weather: WeatherDTO
    arrival_airport_weather: WeatherDTO
    news: NewsDTO
    departure_airport_notams: Notam[]
    arrival_airport_notams: Notam[]
}

export interface Notam {
    ai_interpretation: string
    ai_interpretation_role: string
    ai_main_category: string
    description: string
    message: string
    icao: string
    startdate: Date
    enddate: Date
    ai_timing: string
}

export interface Route {
    route_distance: string
    fixes: Fix[]
}

export interface Fix {
    name: string
    latitude: number
    longitude: number
    distance_from_origin: number
    distance_this_leg: number
    distance_to_destination: number
    outbound_course: number
    type: string
}

export interface NewsDTO {
    articles: Article[]
}

export interface Article {
    lang: string
    date: string
    time: string
    dataType: string
    url: string
    title: string
    body: string
    relevance: string
}

export interface WeatherDTO {
    lat: number
    lon: number
    timezone: string
    timezone_offset: number
    hourly: HourlyData[]
}

export interface HourlyData {
    dt: number
    day_time: Date
    temp: number
    feels_like: number
    pressure: number
    humidity: number
    dew_point: number
    uvi: number
    clouds: number
    visibility: number
    wind_speed: number
    wind_deg: number
    wind_gust: number
    weather: WeatherCondition[]
    pop: number
}

export interface WeatherCondition {
    id: string
    main: string
    description: string
    icon: string
}

export interface FlightDTO {
    flight_number: string
    ident: string
    ident_iata: string
    history: FlightHistoryDTO
    departure: DepartureFlightDTO
    arrival: ArrivalFlightDTO
    aircraft_rotation: FlightDTO[]
    aircraft_name: string
    airline_name: string
    filed_ete: number
    operator: string
    operated_by: string
    operator_iata: string
}

export interface DepartureTabDTO {
    flight_number: string
    scheduled_out: Date
    scheduled_out_tz: Date
    actual_out: Date
    actual_out_tz: Date
    actual_in: Date
    actual_in_tz: Date
    status: FlightHistoryDTO
    departure_delay: string
    arrival_delay: string
    to: AirportDTO
    flight_time: string
    actual_off: Date
    actual_off_tz: Date
    actual_on: Date
    estimated_off: Date
    estimated_on: Date
    scheduled_off: Date
    scheduled_on: Date
    filed_ete: number
    ident: string
    ident_iata: string
    operator: string
    operator_iata: string
    airline_name: string
    from_tz_abbr: string
    from_tz: string
}

export interface ArrivalTabDTO {
    flight_number: string
    scheduled_in: Date
    scheduled_in_tz: Date
    actual_in: Date
    actual_in_tz: Date
    actual_out: Date
    actual_out_tz: Date
    status: FlightHistoryDTO
    arrival_delay: string
    departure_delay: string
    from_: AirportDTO
    flight_time: string
    actual_off: Date
    actual_off_tz: Date
    actual_on: Date
    estimated_off: Date
    estimated_on: Date
    scheduled_off: Date
    scheduled_on: Date
    filed_ete: number
    ident: string
    ident_iata: string
    operator: string
    operator_iata: string
    airline_name: string
    to_tz_abbr: string
    to_tz: string
}

export interface ArrivalFlightDTO {
    airport: AirportDTO
    flight_gate_times: ArrivalFlightGateTimesDTO
    flight_runway_times: ArrivalFlightRunwayTimesDTO
    terminal_and_gate: ArrivalTerminalAndGateDTO
    tail_number: TailNumberDTO
    flight_time: string
}

export interface DepartureFlightDTO {
    airport: AirportDTO
    flight_gate_times: DepartureFlightGateTimesDTO
    flight_runway_times: DepartureFlightRunwayTimesDTO
    terminal_and_gate: DepartureTerminalAndGateDTO
    craft_type: AircraftTypeDTO
    flight_time: string
}

export interface DepartureFlightGateTimesDTO {
    scheduled_out: Date
    scheduled_out_tz: Date
    actual_out: Date
    actual_out_tz: Date
    departure_delay: string
}

export interface DepartureFlightRunwayTimesDTO {
    scheduled_off: Date
    scheduled_off_tz: Date
    actual_off: Date
    actual_off_tz: Date
    runway_delay: string
}

export interface DepartureTerminalAndGateDTO {
    terminal_origin: string
    gate_origin: string
}

export interface AircraftTypeDTO {
    aircraft_type: string
}

export interface FlightHistoryDTO {
    blocked: boolean
    diverted: boolean
    cancelled: boolean
}

export interface AirportDTO {
    name: string
    city: string
    code_icao: string
    code_iata: string
    code_lid: string
    timezone: string
    timezone_abbr: string
}

export interface ArrivalTerminalAndGateDTO {
    terminal_destination: string
    gate_destination: string
    baggage_claim: string
}

export interface ArrivalFlightRunwayTimesDTO {
    scheduled_on: Date
    scheduled_on_tz: Date
    actual_on: Date
    actual_on_tz: Date
    runway_delay: string
}

export interface ArrivalFlightGateTimesDTO {
    scheduled_in: Date
    scheduled_in_tz: Date
    actual_in: Date
    actual_in_tz: Date
    arrival_delay: string
}

export interface TailNumberDTO {
    tail_number: string
}

export interface DistinctAirportResponseDTO {
    departure_airports: string[]
    arrival_airports: string[]
}

export interface GeneratePdfRequestDTO {
    datas: ReportCreatePdfDTO
}

export interface ReportCreatePdfDTO {
    user_info: UserInfoDTO
    report: string
    flight_info: FlightInfoDTO
}

export const ReportErrorMessage = new Map<string, string>([
    ["no flight found", "Nessun volo trovato con questo ident"],
    ["report already exists", "Esiste già un report per questo volo e per questa data"],
    ["api attualmente non disponibile, riprova più tardi", "L'API non è attualmente disponibile, riprovare più tardi"]
])